export var ActionType;
(function (ActionType) {
    ActionType["MOVE"] = "move";
    ActionType["CHECK_BOARD"] = "check board";
    ActionType["SET_SEED"] = "set seed";
})(ActionType || (ActionType = {}));
export var OrbType;
(function (OrbType) {
    OrbType[OrbType["VOID"] = -1] = "VOID";
    OrbType[OrbType["NORMAL"] = 0] = "NORMAL";
    OrbType[OrbType["STRIPPED_VER"] = 1] = "STRIPPED_VER";
    OrbType[OrbType["STRIPPED_HOR"] = 2] = "STRIPPED_HOR";
    OrbType[OrbType["WRAPPED"] = 3] = "WRAPPED";
    OrbType[OrbType["BOMB"] = 4] = "BOMB";
    OrbType[OrbType["PULSATING"] = 5] = "PULSATING";
    OrbType[OrbType["BIG_STRIPED"] = 6] = "BIG_STRIPED";
})(OrbType || (OrbType = {}));
export var Match;
(function (Match) {
    Match["SAME_COLOUR"] = "same-color";
    Match["PULSATING"] = "pulsating";
    Match["COMBO_STRIPED_STRIPED"] = "combo-striped-striped";
    Match["COMBO_WRAPPED_STRIPED"] = "combo-wrapped-striped";
    Match["COMBO_WRAPPED_WRAPPED"] = "combo-wrapped-wrapped";
    Match["COMBO_BOMB_NORMAL"] = "combo-bomb-normal";
    Match["COMBO_BOMB_STRIPED"] = "combo-bomb-striped";
    Match["COMBO_BOMB_WRAPPED"] = "combo-bomb-wrapped";
    Match["COMBO_BOMB_BOMB"] = "combo-bomb-bomb";
})(Match || (Match = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL1R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVlBLE1BQU0sQ0FBTixJQUFZLFVBSVg7QUFKRCxXQUFZLFVBQVU7SUFDbEIsMkJBQWEsQ0FBQTtJQUNiLHlDQUEyQixDQUFBO0lBQzNCLG1DQUFxQixDQUFBO0FBQ3pCLENBQUMsRUFKVyxVQUFVLEtBQVYsVUFBVSxRQUlyQjtBQTZDRCxNQUFNLENBQU4sSUFBWSxPQVNYO0FBVEQsV0FBWSxPQUFPO0lBQ2Ysc0NBQVMsQ0FBQTtJQUNULHlDQUFVLENBQUE7SUFDVixxREFBZ0IsQ0FBQTtJQUNoQixxREFBZ0IsQ0FBQTtJQUNoQiwyQ0FBVyxDQUFBO0lBQ1gscUNBQVEsQ0FBQTtJQUNSLCtDQUFhLENBQUE7SUFDYixtREFBZSxDQUFBO0FBQ25CLENBQUMsRUFUVyxPQUFPLEtBQVAsT0FBTyxRQVNsQjtBQUVELE1BQU0sQ0FBTixJQUFZLEtBVVg7QUFWRCxXQUFZLEtBQUs7SUFDYixtQ0FBMEIsQ0FBQTtJQUMxQixnQ0FBdUIsQ0FBQTtJQUN2Qix3REFBK0MsQ0FBQTtJQUMvQyx3REFBK0MsQ0FBQTtJQUMvQyx3REFBK0MsQ0FBQTtJQUMvQyxnREFBdUMsQ0FBQTtJQUN2QyxrREFBeUMsQ0FBQTtJQUN6QyxrREFBeUMsQ0FBQTtJQUN6Qyw0Q0FBbUMsQ0FBQTtBQUN2QyxDQUFDLEVBVlcsS0FBSyxLQUFMLEtBQUssUUFVaEIifQ==